export default __webpack_public_path__ + "static/media/hipercard.42797260.svg";